import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { GetProductCommentsViewModelPaginationViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'

import { COMMENTS_PAGE_SIZE } from '../_components/ugc-get/constants'
import { PDPReactQueryKeys } from '../types'

export const useGetComments = (id: string, pageNumber: number) => {
    return useQuery<GetProductCommentsViewModelPaginationViewModel>({
        queryKey: [PDPReactQueryKeys.Comments, { page: pageNumber, id }],
        queryFn: () =>
            fetchRequest({
                serviceName: 'cml',
                method: 'GET',
                endpoint: `/products/id/${id}/comments?page_number=${pageNumber}&page_size=${COMMENTS_PAGE_SIZE}`,
            }),
        enabled: !!id,
        staleTime: Infinity,
        placeholderData: keepPreviousData,
    })
}
